module.exports = __webpack_public_path__ + "cec3b20e2eb132480fc2dde19b3bd49a.jpg";